import React from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

import _ from 'lodash';

// Redux form
import { Field, reduxForm, change, formValueSelector, reset } from 'redux-form';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Row, Col } from 'react-bootstrap';
import s from './SearchForm.css';

// Submit Action
import submit from './submit';

// Locale
import messages from '../../../locale/messages';

// Components
import DateRange from '../../../components_new/common/FormComponents/DateRange/SearchDateRange';
import CustomCheckbox from '../../CustomCheckbox';
import PlacesSuggest from '../PlacesSuggest';
import PriceRange from '../PriceRange';
import CurrencyConverter from '../../CurrencyConverter';
import Switch from './Switch';
import SearchInput from '../../../components/SearchInput/SearchInput';

// Redux Action
import {
  openSearchFilter,
  closeSearchFilter,
  closeAndSubmitSearchFilter,
} from '../../../actions/toggleControl';
import { setPersonalizedValues } from '../../../actions/personalized';
import styled from 'styled-components';
import { Text } from '../../../components_new/common';
import Button from '../../../components_new/common/FormComponents/Button';
import Input from '../../../components_new/common/FormComponents/InputStyle';
import { Flex, Box, Absolute } from 'rebass';
import { colors } from '../../../tailwind';
import { CatMenu, MenuChoice } from '../../../components_new/SortBarComps';
import { categoryUploadDir } from '../../../config';
import RatingsPicker from '../../../components_new/common/RatingsPicker';
import history from '../../../core/history';
import { FILTER_CATEGORIES } from '../../siteadmin/BulkListings/BulkListingsStore';

class SearchForm extends React.Component {
  static propTypes = {
    initialFilter: PropTypes.shape({
      geography: PropTypes.string,
      address: PropTypes.string,
      personCapacity: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      formatMessage: PropTypes.func,
    }),
    fieldsSettingsData: PropTypes.shape({
      roomType: PropTypes.array.isRequired,
      personCapacity: PropTypes.array.isRequired,
      bedrooms: PropTypes.array.isRequired,
      bathrooms: PropTypes.array.isRequired,
      beds: PropTypes.array.isRequired,
      essentialsAmenities: PropTypes.array.isRequired,
      spaces: PropTypes.array.isRequired,
      listingRules: PropTypes.array.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    initialFilter: {
      geography: null,
      address: null,
      personCapacity: null,
      startDate: null,
      endDate: null,
    },
    fieldsSettingsData: {
      roomType: [],
      personCapacity: [],
      bedrooms: [],
      bathrooms: [],
      beds: [],
      essentialsAmenities: [],
      spaces: [],
      listingRules: [],
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      keyword: '',
      city: '',
      categories: FILTER_CATEGORIES,
      selectedCategories: [],
      query: {},
      startDate: '',
      endDate: '',
      location: '',
      priceMin: 0,
      priceMax: 0,
      filtering: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { query = {} } = nextProps;
    const innerQuery = this.state.query;
    // change this to set location, startDate, endDate
    if (query !== innerQuery) {
      let startDate;
      let endDate;
      let selectedCategories;
      const location = query.location;
      const priceMin = query.priceMin;
      const priceMax = query.priceMax;
      const keyword = query.keyword;
      const minRating = query.minRating;
      const category = query.category;

      if (query.dates) {
        const dateArr = query.dates.split('AND');
        startDate = dateArr[0].trim().replace("'", '');
        endDate = dateArr[1].trim().replace("'", '');
      }

      if (category) {
        if (Array.isArray(category)) {
          selectedCategories = category;
        } else {
          selectedCategories = [category];
        }
      } else {
        selectedCategories = [];
      }

      this.setState({
        query,
        startDate,
        endDate,
        location,
        selectedCategories,
        priceMin,
        priceMax,
        keyword,
        minRating,
        clearing: !startDate && this.state.startDate,
      });
    }
  }

  handleInputChange = (val, prop) => {
    this.setState({
      [prop]: val,
    });
  };

  // handleFilterClose() {
  //   const { closeSearchFilter } = this.props;
  //   closeSearchFilter();
  // }

  // handleFilterClick() {
  //   const { openSearchFilter } = this.props;
  //   openSearchFilter();
  // }

  // handleFilterSubmit() {
  //   const { closeAndSubmitSearchFilter, handleSubmit, change } = this.props;
  //   closeAndSubmitSearchFilter();
  //   change('currentPage', 1);
  //   setTimeout(handleSubmit(submit));
  // }

  categoryChanged = (cat, event) => {
    const newCats = this.state.selectedCategories.slice();
    if (newCats.indexOf(cat.id.toString()) >= 0) {
      newCats.splice(newCats.indexOf(cat.id.toString()), 1);
    } else {
      newCats.push(cat.id.toString());
    }
    this.setState({
      selectedCategories: newCats,
    });
  };

  dateFilterChanged = val => {
    this.setState({
      startDate: val.startDate,
      endDate: val.endDate,
    });
  };

  changeMinRating = rating => {
    this.setState({
      minRating: rating,
    });
  };

  buildTags = () => {
    if (!this.props.query) {
      return;
    }
    const {
      query: {
        priceMin,
        priceMax,
        keyword,
        startDate,
        endDate,
        location,
        category,
        minRating,
      },
      change,
    } = this.props;
    const { categories, filterHash, searchedTags } = this.state;

    const tags = [];
    if (category && category.length) {
      if (category.indexOf(',') >= 0) {
        const catArr = category.split(',');
        catArr.forEach(cat => {
          const catMatch = categories[+cat];
          const catName = `category: ${
            catMatch !== undefined ? catMatch : '?*?'
          }`;
          tags.push(
            <Tag delete={() => this.deleteTag('category', cat)}>{catName}</Tag>,
          );
        });
      } else if (Array.isArray(category)) {
        const catArr = category;
        catArr.forEach(cat => {
          const catMatch = categories[+cat];
          const catName = `category: ${
            catMatch !== undefined ? catMatch : '?*?'
          }`;
          tags.push(
            <Tag delete={() => this.deleteTag('category', cat)}>{catName}</Tag>,
          );
        });
      } else {
        const catMatch = categories[+category];
        const catName = `category: ${
          catMatch !== undefined ? catMatch : '?*?'
        }`;
        tags.push(
          <Tag delete={() => this.deleteTag('category', category)}>
            {catName}
          </Tag>,
        );
      }
    }
    if (keyword && keyword.length) {
      tags.push(
        <Tag delete={() => this.deleteTag('keyword')}>keyword: {keyword}</Tag>,
      );
    }
    if (location && location.length) {
      tags.push(
        <Tag delete={() => this.deleteTag('location')}>
          location: {location}
        </Tag>,
      );
    }
    if (startDate && startDate.length && endDate && endDate.length) {
      tags.push(
        <Tag delete={() => this.deleteTag('availability')}>
          availability: {startDate} - {endDate}
        </Tag>,
      );
    }
    if (minRating && minRating.length) {
      tags.push(
        <Tag delete={() => this.deleteTag('minRating')}>
          min rating: {minRating}
        </Tag>,
      );
    }
    if ((priceMin && priceMin.length) || (priceMax && priceMax.length)) {
      tags.push(
        <Tag delete={() => this.deleteTag('price')}>
          price: {priceMin || 0} - {priceMax || '$$'}
        </Tag>,
      );
    }
    if (tags.length > 0) {
      return <React.Fragment>{tags}</React.Fragment>;
    }
    return null;
  };

  deleteTag = (field, arg) => {
    const { query } = this.props;
    if (field === 'category') {
      const { category } = query;
      const catArr = Array.isArray(category) ? category : category.split(',');
      const loc = catArr.indexOf(arg.toString());
      catArr.splice(loc, 1);
      query.category = catArr;
    } else if (query[field]) {
      delete query[field];
      if (field === 'location') {
        delete query.lat;
        delete query.lng;
      }
    } else if (field === 'price') {
      delete query.priceMin;
      delete query.priceMax;
    } else if (field === 'availability') {
      delete query.startDate;
      delete query.endDate;
    }

    const newQuery = this.buildQuery(query, 'category');

    history.push(`/s?${newQuery}`);
  };

  searchPosted = () => {
    const {
      startDate,
      endDate,
      location,
      selectedCategories,
      priceMin,
      priceMax,
      keyword,
      minRating,
      lat,
      lng,
    } = this.state;

    const params = {};

    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    if (location) {
      params.location = location;
    }
    if (selectedCategories && selectedCategories.length > 0) {
      params.selectedCategories = selectedCategories;
    }
    if (priceMin) {
      params.priceMin = priceMin;
    }
    if (priceMax) {
      params.priceMax = priceMax;
    }
    if (keyword) {
      params.keyword = keyword;
    }
    if (minRating) {
      params.minRating = minRating;
    }
    if (lat) {
      params.lat = lat;
    }
    if (lng) {
      params.lng = lng;
    }

    const query = this.buildQuery(params, 'selectedCategories');

    this.setState({
      filtering: false,
    });

    history.push(`/s?${query}`);
  };

  buildQuery = (queryBase, categoryKey) => {
    if (!_ || !queryBase) {
      return queryBase;
    }
    const query = _.map(queryBase, (v, k) => {
      if (k === categoryKey && v.length > 0) {
        return v.map(cat => `category=${cat}`).join('&');
      }
      return `${k}=${v}`;
    }).join('&');
    return query;
  };

  cancelSearch = async () => {
    this.setState({
      clearing: true,
      filtering: false,
    });

    history.push('/s');
  };

  toggleFiltering = () => {
    this.setState({
      filtering: !this.state.filtering,
    });
  };

  clearClear = () => {
    this.setState({
      clearing: false,
    });
  };

  searchKeyed = e => {
    if (e.keyCode === 13) {
      this.searchPosted();
    } else if (e.keyCode === 27) {
      this.setState(
        {
          keyword: '',
        },
        () => this.searchPosted(),
      );
    }
  };

  render() {
    const { error, filterToggle, change } = this.props;
    const { formatMessage } = this.props.intl;
    const { applied, handleSubmit } = this.props;
    const {
      categories,
      startDate,
      endDate,
      location,
      selectedCategories,
      priceMin,
      priceMax,
      keyword,
      minRating,
      clearing,
      filtering,
    } = this.state;

    const catChoices = _.map(categories, (catName, catId) => {
      const selected = !!(
        selectedCategories && selectedCategories.indexOf(catId.toString()) >= 0
      );
      return (
        <Box
          style={{
            flexBasis: '200px',
          }}
          mb={2}
        >
          <CustomCheckbox
            name={catName + '_checkbox'}
            value={selected}
            checked={selected}
            onChange={event =>
              this.categoryChanged({ id: catId, itemName: catName }, event)
            }
          />
          <Text inline ml={3}>
            {catName}
          </Text>
        </Box>
      );
    });

    const tags = this.buildTags();

    return (
      <div>
        {error && <strong>{formatMessage(error)}</strong>}
        <Flex
          flexDirection="column"
          style={{ width: '100%' }}
          className="b-0 bb-1 b-cool-gray-light mb-l"
        >
          <Flex
            justifyContent="space-between"
            style={{
              padding: '16px',
            }}
          >
            <div className="f-sc f-columns">
              <div className="relative">
                <input
                  name="keyword"
                  onChange={e =>
                    this.handleInputChange(e.target.value, 'keyword')
                  }
                  onKeyUp={this.searchKeyed}
                  placeholder="Search here.."
                  id="keyword-search-input"
                  value={this.state.keyword}
                  className="mr-m b-0 bb-1 b-primary-light pl-lxx h-35 pn t-l"
                />
                <i className="fal fa-search absolute bottom-11 left-3 primary t-l" />
              </div>
              <div className="relative">
                <PlacesSuggest
                  label={'Enter your city'}
                  location={location}
                  change={this.handleInputChange}
                />
                <i className="fas fa-map-marker-alt absolute bottom-11 left-3 primary t-l" />
              </div>
            </div>
            <Flex flexDirection="row" alignItems="center">
              <Text link clickable mr={3} onClick={this.toggleFiltering} yid="advanced-search-link">
                Advanced search
              </Text>
              <Button secondary onClick={this.searchPosted}>
                Search
              </Button>
            </Flex>
          </Flex>
          <Box className={tags ? 'mb-l' : ''}>{tags}</Box>
        </Flex>
        {filtering && (
          <Flex
            flex={1}
            flexDirection="column"
            p={'22px'}
            flexBasis="200px"
            style={{ position: 'relative' }}
          >
            <Absolute top="0px" right="15px">
              <Flex>
                <Button
                  secondary
                  muted
                  mr="8px"
                  type="button"
                  onClick={this.cancelSearch}
                >
                  Clear all
                </Button>
              </Flex>
            </Absolute>
            <FilterSection
              sectionName="Category"
              render={p => (
                <Flex flexWrap="wrap" mt={2}>
                  {catChoices}
                </Flex>
              )}
            />

            <Splitter />
            <FilterSection
              sectionName="Availability & Ratings"
              render={p => (
                <Flex>
                  <Box style={{ display: 'inline-block' }}>
                    <DateRange
                      name="dates"
                      formName={'SearchForm'}
                      numberOfMonths={1}
                      personalized={{ startDate, endDate }}
                      clearing={clearing}
                      clearClear={this.clearClear}
                      onChange={
                        this.dateFilterChanged ||
                        ((formName, fieldName, value) => {
                          console.log(
                            'DATE SELECTED',
                            formName,
                            fieldName,
                            value,
                          );
                        })
                      }
                    />
                  </Box>
                  <Box ml={4}>
                    <Text
                      family="Helvetica"
                      size="14px"
                      weight="normal"
                      color="#595959"
                      margin="6px 0px"
                    >
                      Min. Rating
                    </Text>
                    <RatingsPicker
                      medium
                      rating={minRating}
                      changeMinRating={this.changeMinRating}
                      id="ratings-picker"
                    />
                  </Box>
                </Flex>
              )}
            />
            <Splitter />
            <FilterSection
              sectionName="Price"
              render={p => (
                <Flex flexDirection="column">
                  <Flex>
                    <Box mr={4}>
                      <Text>Min</Text>
                      <Input
                        type="number"
                        name="priceMin"
                        onChange={e =>
                          this.handleInputChange(e.target.value, 'priceMin')
                        }
                        placeholder="Optional"
                        id="price-min-text"
                        validationState={null}
                        defaultValue={priceMin}
                      />
                    </Box>
                    <Box>
                      <Text>Max</Text>
                      <Input
                        type="number"
                        name="priceMax"
                        onChange={e =>
                          this.handleInputChange(e.target.value, 'priceMax')
                        }
                        placeholder="Optional"
                        id="price-max-text"
                        validationState={null}
                        defaultValue={priceMax}
                      />
                    </Box>
                  </Flex>
                </Flex>
              )}
            />
            <Splitter />
          </Flex>
        )}
      </div>
    );
  }
}

const mapState = state => ({
  fieldsSettingsData: state.listingFields.data,
  personalized: state.personalized,
});

export default injectIntl(
  withStyles(s)(
    connect(
      mapState,
      {},
    )(SearchForm),
  ),
);

function FilterSection(props) {
  return (
    <Box mb={2}>
      <Text emphasis grayDarkMedium mb={2}>
        {props.sectionName}
      </Text>
      {props.render()}
    </Box>
  );
}

const Splitter = styled.div`
  width: 100%;
  height: 1px;
  margin: 0 auto;
  margin-top: 22px;
  margin-bottom: 22px;
  border-bottom: 1px solid ${colors.coolGrayLight};
`;

function Tag(props) {
  return (
    <_Tag>
      {props.children}{' '}
      <Text inline white mx={2} large>
        | <i onClick={props.delete} className="fal fa-times" />
      </Text>
    </_Tag>
  );
}

const _Tag = styled.div`
  display: inline-block;
  background-color: ${colors.primary};
  color: white;
  border-radius: 25px;
  padding: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-left: 6px;
  margin-top: 6px;
`;



// WEBPACK FOOTER //
// ./src/components/SearchListing/SearchForm/SearchForm.js